import { css } from 'styled-components';

export const Truncate = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
